// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__31QlS","colCheckbox":"styles_colCheckbox__18NyF"};